import { useParams, Link, useNavigate } from 'react-router-dom';
import { produceData, getProduceById, produceCategoryLabels } from '../data/produceData';
import { ChevronRight, ChevronDown, Apple, Globe, Utensils, Package, Award, MessageSquareQuote, Calendar, Leaf } from 'lucide-react';
import { useState } from 'react';

// AI-Generated produce images
const produceImages = {
  'alphonso-mango': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/bc8824e58cd3f0cd5e99fdea2ca9eecc649ef76f764289be97e3bc4aa0fcb944.png',
  'kesar-mango': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/f5dc066fe8c0c344c6ff5ec8c2571119b6898cdc853f461887cfebc54b6f5488.png',
  'totapuri-mango': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/c171137a69c46b30ea7401bf310c48ee5c704d9538cb918fb2676578e8f25703.png',
  'thompson-grapes': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/e61a6072a834ec7e8508ff71d7eded0ab5f8631d4f500e33fcd88a6f41e49914.png',
  'pomegranate': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/8b2b287dde9feb4c4d615cbf0bd73861196d51d72c53535d28fcb4dd2aafdc7a.png',
  'banana-cavendish': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/b23e84a8fb529cbefa559d2c9a4b68a460412aaccedccc82ebe67e4e0770a412.png',
  'orange-nagpur': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/3d17dd193f7c8c6e19b14a06f6f49957432cda23e2e0dfae3630f30c6e88a12e.png',
  'onion-red': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6f665435ecb11e58759a1f3c1d1daf9090460c57a93ef8266700fe3fec121fca.png',
  'potato': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/cd36a1eaf0c0fb7afa1ff12333e3f3853a3ab4e4dab5862bd91206cfcac81a41.png',
  'green-chilli': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6a5754eaaa7b793d5854fc22e1a0c34dc0ab5094592b562df86f45d41df676a7.png',
  'fresh-ginger': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/39ca211fe2610cc5b7db41687e474336eb8b463243f4d749d7aa32690b349099.png',
  'fresh-garlic': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/74a03f1d78f247be851ca0a126d0763ba0007c51161f2232d3788d5f9d8a05cd.png',
  'okra': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/823b6e1acf80446e561020ef8f1b188a9a61a226b036b316356ccfbfc8605a70.png',
  'mango-pulp': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/2dc079e75c9bf452d00ee5a2b5ebbf55899aa00d6987415ff5c35a7c2936ac4b.png',
  'tomato-paste': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/8d7df9705d2e433bb031eb600c57cd2af46edfd485be27936581517d67654e90.png',
  'dehydrated-onion': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/91cbf6fb6eb7a19244de8dde034d6d36de88b86c96c9babb87913393c82a98cb.png',
  'dehydrated-garlic': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/ec21f43c4cd14bd81c0806345c7e39a255d1134c607c713bdac85b06d01aca57.png',
  'frozen-vegetables': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/cefa93053f2d01243cb0e9d3eaf7d54ac54013ba298ac273e44ade69775d4677.png',
  'pickle-mango': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/6c2e2e5307e863db0f56a60fc47a5f9c5ae0c97540cbe7c9ea65d18f6633ff0f.png',
  'guava-pulp': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/85279c18cae84182b3799fc85fc881027d4a1de2e385f728c4a910b454ffa91e.png',
  'coconut-products': 'https://static.prod-images.emergentagent.com/jobs/71d5fd02-4819-4dfa-92cf-0a0a2bf388cc/images/a23a9a7060288e4104acd6515c9bfdaadedb3b0876d4d2fe14a952e873555bbb.png',
};

const getProduceImage = (imageKey) => {
  return produceImages[imageKey] || 'https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=800&h=500&fit=crop';
};

export default function ProduceDetail() {
  const { produceId } = useParams();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const produce = getProduceById(produceId);

  if (!produce) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-700 mb-4">Product Not Found</h1>
          <Link to="/products/produce" className="text-[#F47D20] hover:underline">
            Return to Fruits & Vegetables Catalogue
          </Link>
        </div>
      </div>
    );
  }

  const handleProduceChange = (newProduceId) => {
    setIsDropdownOpen(false);
    navigate(`/products/produce/${newProduceId}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#263776] via-[#1e2d5f] to-[#263776] text-white">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#F47D20] rounded-full filter blur-3xl translate-x-1/2 -translate-y-1/2"></div>
        </div>
        <div className="container mx-auto px-4 py-8 relative z-10">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm mb-6 text-gray-300">
            <Link to="/" className="hover:text-[#F47D20] transition-colors">Home</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products" className="hover:text-[#F47D20] transition-colors">Products</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <Link to="/products/produce" className="hover:text-[#F47D20] transition-colors">Fruits & Vegetables</Link>
            <ChevronRight className="w-4 h-4 mx-2" />
            <span className="text-[#F47D20]">{produce.name}</span>
          </nav>

          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Image */}
            <div className="w-full lg:w-1/2">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src={getProduceImage(produce.image)}
                  alt={produce.name}
                  className="w-full h-64 md:h-80 object-cover"
                />
                <div className="absolute top-4 right-4 px-3 py-1.5 bg-[#F47D20] text-white text-sm font-medium rounded-full">
                  {produceCategoryLabels[produce.category]}
                </div>
              </div>
            </div>

            {/* Title and Quick Info */}
            <div className="w-full lg:w-1/2">
              {/* Produce Dropdown Selector */}
              <div className="relative mb-6">
                <button
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  className="flex items-center justify-between w-full md:w-80 px-4 py-3 bg-white/10 backdrop-blur border border-white/20 rounded-lg text-left hover:bg-white/20 transition-colors"
                  data-testid="produce-dropdown-toggle"
                >
                  <span className="text-sm">Browse Other Products</span>
                  <ChevronDown className={`w-5 h-5 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
                </button>
                
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-full md:w-80 max-h-64 overflow-y-auto bg-white rounded-lg shadow-xl z-50 border border-gray-200">
                    {produceData.map((p) => (
                      <button
                        key={p.id}
                        onClick={() => handleProduceChange(p.id)}
                        className={`w-full px-4 py-2.5 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between ${
                          p.id === produce.id ? 'bg-[#F47D20]/10 text-[#F47D20]' : 'text-gray-700'
                        }`}
                      >
                        <span>{p.name}</span>
                        {p.id === produce.id && <span className="text-xs">Current</span>}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <h1 className="text-4xl md:text-5xl font-bold mb-2">{produce.name}</h1>
              <p className="text-xl text-gray-300 italic mb-6">{produce.botanicalName}</p>
              
              {/* Quick Info Cards */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-white/10 backdrop-blur rounded-lg p-4">
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">Origin</div>
                  <div className="font-semibold text-sm">{produce.origin.split(' - ')[0]}</div>
                </div>
                <div className="bg-white/10 backdrop-blur rounded-lg p-4">
                  <div className="text-xs text-gray-400 uppercase tracking-wide mb-1">Season</div>
                  <div className="font-semibold text-sm">{produce.season}</div>
                </div>
              </div>

              {/* Get Quote Button */}
              <Link
                to={`/contact?product=${encodeURIComponent(produce.name)}&type=Quote%20Request`}
                className="inline-flex items-center px-6 py-3 bg-[#F47D20] text-white font-semibold rounded-lg hover:bg-[#e06d10] transition-colors shadow-lg"
                data-testid="get-quote-btn"
              >
                <MessageSquareQuote className="w-5 h-5 mr-2" />
                Get Quote for {produce.name}
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-8">
            {/* Description */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#263776]/10 rounded-lg flex items-center justify-center">
                  <Apple className="w-5 h-5 text-[#263776]" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Description</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{produce.description}</p>
            </section>

            {/* Characteristics */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#F47D20]/10 rounded-lg flex items-center justify-center">
                  <Leaf className="w-5 h-5 text-[#F47D20]" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Characteristics</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{produce.characteristics}</p>
            </section>

            {/* Culinary Uses */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <Utensils className="w-5 h-5 text-green-600" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Culinary Uses</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{produce.culinaryUses}</p>
            </section>

            {/* Nutritional Info */}
            <section className="bg-white rounded-xl shadow-sm p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                  <Globe className="w-5 h-5 text-blue-600" />
                </div>
                <h2 className="text-2xl font-bold text-[#263776]">Nutritional Information</h2>
              </div>
              <p className="text-gray-700 leading-relaxed">{produce.nutritionalInfo}</p>
            </section>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Specifications */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                  <Package className="w-5 h-5 text-purple-600" />
                </div>
                <h2 className="text-lg font-bold text-[#263776]">Specifications</h2>
              </div>
              <div className="space-y-2">
                {Object.entries(produce.specifications).map(([key, value]) => (
                  <div key={key} className="flex justify-between py-2 border-b border-gray-100 last:border-0">
                    <span className="text-gray-500 text-sm capitalize">{key.replace(/([A-Z])/g, ' $1').trim()}</span>
                    <span className="font-medium text-gray-800 text-sm text-right max-w-[60%]">{value}</span>
                  </div>
                ))}
              </div>
            </section>

            {/* Grades */}
            {produce.grades && (
              <section className="bg-white rounded-xl shadow-sm p-6">
                <h2 className="text-lg font-bold text-[#263776] mb-3">Available Grades</h2>
                <div className="flex flex-wrap gap-2">
                  {produce.grades.map((grade, index) => (
                    <span key={index} className="px-3 py-1 bg-[#263776]/10 text-[#263776] text-sm rounded-full">
                      {grade}
                    </span>
                  ))}
                </div>
              </section>
            )}

            {/* Season */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                  <Calendar className="w-5 h-5 text-orange-600" />
                </div>
                <h2 className="text-lg font-bold text-[#263776]">Availability</h2>
              </div>
              <p className="text-gray-600 text-sm">{produce.season}</p>
            </section>

            {/* Certifications */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                  <Award className="w-5 h-5 text-green-600" />
                </div>
                <h2 className="text-lg font-bold text-[#263776]">Certifications</h2>
              </div>
              <p className="text-gray-600 text-sm">{produce.certifications}</p>
            </section>

            {/* Packaging & Shelf Life */}
            <section className="bg-white rounded-xl shadow-sm p-6">
              <h2 className="text-lg font-bold text-[#263776] mb-3">Packaging</h2>
              <p className="text-gray-600 text-sm mb-4">{produce.packaging}</p>
              <h2 className="text-lg font-bold text-[#263776] mb-3">Shelf Life</h2>
              <p className="text-gray-600 text-sm">{produce.shelfLife}</p>
            </section>

            {/* CTA Card */}
            <div className="bg-gradient-to-br from-[#263776] to-[#1e2d5f] rounded-xl p-6 text-white">
              <h3 className="text-lg font-bold mb-3">Interested in {produce.name}?</h3>
              <p className="text-gray-300 text-sm mb-4">
                Get competitive pricing, bulk quantities, and custom specifications for your business needs.
              </p>
              <Link
                to={`/contact?product=${encodeURIComponent(produce.name)}&type=Quote%20Request`}
                className="block w-full py-3 bg-[#F47D20] text-center font-semibold rounded-lg hover:bg-[#e06d10] transition-colors"
                data-testid="sidebar-get-quote-btn"
              >
                Request Quote
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Related Products */}
      <div className="bg-gray-100 py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl font-bold text-[#263776] mb-6">Related Products</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {produceData
              .filter(p => p.id !== produce.id && p.category === produce.category)
              .slice(0, 6)
              .map((relatedProduce) => (
                <Link
                  key={relatedProduce.id}
                  to={`/products/produce/${relatedProduce.id}`}
                  className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all"
                >
                  <div className="h-24 overflow-hidden">
                    <img
                      src={getProduceImage(relatedProduce.image)}
                      alt={relatedProduce.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-3">
                    <h3 className="font-medium text-sm text-[#263776] group-hover:text-[#F47D20] transition-colors truncate">
                      {relatedProduce.name}
                    </h3>
                  </div>
                </Link>
              ))}
          </div>
          
          <div className="text-center mt-8">
            <Link
              to="/products/produce"
              className="inline-flex items-center px-6 py-3 border-2 border-[#263776] text-[#263776] font-semibold rounded-lg hover:bg-[#263776] hover:text-white transition-colors"
            >
              View Full Catalogue
              <ChevronRight className="w-5 h-5 ml-2" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
